import { inject } from '@angular/core'
import { signalStore, withMethods } from '@ngrx/signals'
import { rxMethod } from '@ngrx/signals/rxjs-interop'
import { withDevtools } from '@angular-architects/ngrx-toolkit'
import { ToastService } from '@performance/ui'
import { TranslateService } from '@ngx-translate/core'
import { Toast } from '@core/domain/models/common.models'
import { forkJoin, map, of, pipe, switchMap } from 'rxjs'

export const ToastStore = signalStore(
  { providedIn: 'root' },
  withDevtools('toast'),
  withMethods((_store, toast = inject(ToastService), translate = inject(TranslateService)) => ({
    show: rxMethod<Toast>(
      pipe(
        switchMap((t) =>
          forkJoin(
            [t.title, t.body].map((text) => (text ? translate.get(text) : of(undefined))),
          ).pipe(map(([title, body]) => ({ ...t, title, body }))),
        ),
        map(({ title, body, variant, duration, closeable }) =>
          toast.show({ title, body, variant: variant || 'success', duration, closeable }),
        ),
      ),
    ),
  })),
)
